import styled from '@emotion/styled';

import { GNB_HEIGHT } from '../../../constants/layout';
import GnbLeftSideComponent from './GnbLeftSideComponent';
import GnbRightSideComponent from './GnbRightSideComponent';
import GnbSearchButton from './Search/SearchButton';
import { SearchPopoverProvider as GnbSearchProvider } from './Search/SearchPopoverProvider';

const GnbContainer = styled('nav')`
  display: flex;
  align-items: center;
  height: ${GNB_HEIGHT}px;

  text-align: center;
  background-color: ${({ theme }) => theme.color['surface/global/default']};
`;

const GnbMenuList = styled('ul')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0;
`;

const Gnb = () => (
  <GnbContainer>
    <GnbMenuList>
      <GnbLeftSideComponent />
      <GnbSearchProvider>
        <GnbSearchButton />
      </GnbSearchProvider>
      <GnbRightSideComponent />
    </GnbMenuList>
  </GnbContainer>
);

export default Gnb;
